<mat-form-field
  appearance="outline"
  class="align-right"
  [ngClass]="{ fill: searchText }"
>
  <mat-label>{{ text }}</mat-label>
  <ng-icon
    name="HeroSearch"
    matPrefix
    class="icon-fw search-prefix-icon"
    aria-hidden="true"
  ></ng-icon>
  @if (searchText) {
    <ng-icon
      name="HeroX"
      matSuffix
      aria-label="Clear search"
      (click)="clear()"
      class="mouse-pointer close-icon icon-fw"
    ></ng-icon>
  }
  <input
    matInput
    (keyup)="keyUp($event)"
    [placeholder]="text"
    [(ngModel)]="searchText"
  />
</mat-form-field>
